import React from 'react';
import { Card, CardHeader, CardMedia, CardActionArea, Box } from '@mui/material';
import ButtonNav from '../button/ButtonNav';

export default function CardPrestation({ prestation }) {

	return (
		<>
			<Card sx={{ color: '#555555', backgroundColor: '#F7F7F7', mb: 4, borderRadius: 0, boxShadow: 10 }}>
				<CardActionArea href={process.env.REACT_APP_CATALOGUE_URL + '/' + prestation.key + '/'}>
					<CardHeader
						sx={{ height: '80px', backgroundColor: '#004AFE', color: '#FFFFFF', textAlign: 'center' }}
						titleTypographyProps={{ fontSize: 18, fontWeight: 600 }}
						title={prestation.label}
					/>
					<CardMedia
						component="img"
						height="100%"
						image={process.env.REACT_APP_PATH_IMAGES + '/prestations/' + prestation.key + '-sm.webp'}
						alt={prestation.label}
					/>
					<Box textAlign='center' paddingTop={4} paddingBottom={4}>
						<ButtonNav props={{ text: 'Voir les produits' }} />
					</Box>
				</CardActionArea>
			</Card>
		</>
	);
}